import { render, staticRenderFns } from "./NuovaCommessaMultipla.vue?vue&type=template&id=edbb1ec6&"
import script from "./NuovaCommessaMultipla.vue?vue&type=script&lang=js&"
export * from "./NuovaCommessaMultipla.vue?vue&type=script&lang=js&"
import style0 from "./NuovaCommessaMultipla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports